import React, {useContext, useState} from 'react';
import './TaskCategory.css'
import {useNavigate} from "react-router-dom";
import comment from "../../accets/img/comment.png";
import paper_clip from "../../accets/img/paper_clip.png";
import SearchComponent from "../SearchComponent/SearchComponent";
import {Context} from "../../index";
import cancel from "../../accets/img/cancel.png";
import good from "../../accets/img/Good.png";
import {observer} from "mobx-react-lite";

const MyTask = () => {

    const navigate = useNavigate()
    const {taskStore, fileStore, commentStore, statementStore, userStore} = useContext(Context)

    const [searchName, setSearchName] = useState('')

    let date = new Intl.DateTimeFormat("ru-RU", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
    })

    const filteredTask = taskStore.task.filter(task => task
        ?
        task.name?.toLowerCase().includes(searchName.toLowerCase())
        :
        false)

    const TaskWithFileAndComment = filteredTask.map(task => {
        const withFileId = fileStore.file.filter(file => file['taskId'] === task['id'])
        const file = withFileId.reduce((acc, curr) => {
            acc.push(curr)
            return acc
        }, [])
        const withCommentId = commentStore.comments.filter(comm => comm['taskId'] === task['id'])
        const comm = withCommentId.reduce((acc, curr) => {
            acc.push(curr)
            return acc
        }, [])
        const withSratementId = statementStore.statement.filter(state => state['taskId'] === task['id'])
        const state = withSratementId.reduce((acc, curr) => {
            acc.push(curr)
            return acc
        }, [])
        return {...task, fileto: file, comment: comm, statement: state}
    })

    return (
        <div className="tasks__block">

            <SearchComponent setSearchName={setSearchName} searchName={searchName}/>

            <div className="one__tasks__block">
                <div className="one__tasks one__tasks_statement">
                    <div className="task__category">
                        Мои задачи
                    </div>
                    <div className="one__tasks__block__cat">

                        {TaskWithFileAndComment.filter(i => i.executor === userStore.user.id && i.status !== "CLOSE")
                            .sort(({id: previoudID}, {id: currentID}) => previoudID - currentID)
                            .map(task =>
                                <div key={task.id}
                                     className="task"
                                     onClick={() => navigate(`/job/task/${task.id}`)}
                                >
                                    <div style={{display: 'flex', alignItems: 'center'}}>
                                        <div
                                            className={`date__block ${task.priority === 1 ? 'date__block__p1' : ''} ${task.priority === 2 ? 'date__block__p2' : ''} ${task.priority === 3 ? 'date__block__p3' : ''} ${task.priority === 4 ? 'date__block__p4' : ''}`}
                                        >
                                            <div className="num__block">{task.id}</div>
                                            <div className="date__block">{date.format(Date.parse(task.createdAt))}</div>
                                        </div>
                                        {!task.name
                                            ?
                                            <div className="name__task">Без наименования</div>
                                            :
                                            <div className="name__task">{task.name}</div>
                                        }
                                    </div>
                                    <div>
                                        <div className="com__block">
                                            {task.statement.filter(s => s.status === "NO").map(j =>
                                                <div key={j.id} className="com">
                                                    <img src={cancel} alt={cancel}/>
                                                </div>
                                            )

                                            }
                                            {task.statement.filter(s => s.status === "YES").map(j =>
                                                <div key={j.id} className="com">
                                                    <img src={good} alt={good}/>
                                                </div>
                                            )

                                            }

                                            {task.comment.length
                                                ?
                                                <div className="com">
                                                    <img src={comment} alt={comment}/>
                                                    <div className="com__num">{task.comment.length}</div>
                                                </div>
                                                : null
                                            }

                                            {task.fileto.length
                                                ?
                                                <div className="paper__clip">
                                                    <img src={paper_clip} alt={paper_clip}/>
                                                </div>
                                                : null
                                            }

                                        </div>
                                    </div>

                                </div>
                            )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default observer(MyTask);